import { AyTracking } from '@aboutyou/legacy-tracking-sdk'
import useShowLoginPrompt from 'helpers/hooks/useShowLoginPrompt'
import { useTracking } from 'helpers/tracking/hooks/useTrackingContextAndClientV6'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useUserStore } from 'store/context'
import UserStore from 'store/features/user'
import styled from 'styled-components'
import { Icon } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import * as colors from 'uiComponents/constants/colors'

function handleClick(
  brandId: string,
  brandUrl: string,
  isLiked: boolean,
  isLoggedIn: boolean,
  userStore: UserStore,
  showLoginPrompt: VoidFunction,
  TrackingClient: AyTracking,
) {
  if (isLoggedIn) {
    userStore.likeBrand(brandId, !isLiked)
  } else {
    showLoginPrompt()
  }

  TrackingClient?.trackContentInteraction({
    interaction: {
      action: isLiked ? 'unlike' : 'like',
      label: brandId,
      name: brandUrl.split('/').reverse()[0],
      type: 'brand',
      url: brandUrl,
    },
  })
}

const Like: React.FC<{
  className?: string
  liked: boolean
  brandId: string
  brandUrl: string
}> = ({ className, liked, brandId, brandUrl }) => {
  const userStore = useUserStore()
  const isLoggedIn = useObserver(() => userStore.isLoggedIn)
  const { TrackingClient } = useTracking()
  const showLoginPrompt = useShowLoginPrompt()

  const handleOnClick = () => {
    handleClick(
      brandId,
      brandUrl,
      liked,
      isLoggedIn,
      userStore,
      showLoginPrompt,
      TrackingClient,
    )
  }

  return (
    <button className={className} type="button" onClick={handleOnClick}>
      <StyledIcon $isLiked={liked} asset={IconName.IcWishlist} />
    </button>
  )
}

const StyledIcon = styled(Icon)<{ $isLiked: boolean }>`
  fill: ${colors.white};
  stroke: ${colors.primaryColor};
  stroke-width: 2px;
  ${({ $isLiked }) => $isLiked && `fill: ${colors.primaryColor};`}

  &:hover {
    fill: ${colors.primaryColor};
  }
`

export default Like
